export const styles = {
  root: {},
  title: {
    fontWeight: 700,
    fontSize: "1rem",
  },
}
